import { storeAnnouncementCampaignCompleted } from 'modules/campaigns'
import {
  getActiveCampaignId,
  getActiveCampaignPlaybookId,
  getHasChatCtaForActiveCampaign,
  hasActiveCampaign,
  isActiveWelcomeMessageCampaign} from 'modules/campaigns/selectors'
import { createConversationEvent } from 'modules/conversations'
import { sendMessage as sendMessageAction } from 'modules/conversations/actions'
import { hasActiveConversation } from 'modules/conversations/selectors'
import { sendMessage as sendMessageToServer } from 'modules/message/sender'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ConversationEventType } from 'types/conversation'

const useSendMessage = () => {
  const dispatch = useDispatch()
  const isInActiveConversation = useSelector(hasActiveConversation)
  const isWelcomeMessageCampaign = useSelector(isActiveWelcomeMessageCampaign)
  const isInActiveCampaign = useSelector(hasActiveCampaign)
  const activeCampaignId = useSelector(getActiveCampaignId)
  const activeCampaignPlaybookId = useSelector(getActiveCampaignPlaybookId)
  const activeCampaignHasChatCta = useSelector(getHasChatCtaForActiveCampaign)

  const sendMessage = useCallback((payload) => {
    dispatch(sendMessageAction(payload))
  }, [dispatch])

  const sendChatMessage = useCallback((payload) => {
    if (isInActiveConversation && isInActiveCampaign && isWelcomeMessageCampaign) {
      if (activeCampaignHasChatCta) {
        createConversationEvent(ConversationEventType.SUBMITTED)
      }

      storeAnnouncementCampaignCompleted(activeCampaignId, activeCampaignPlaybookId)
    }

    sendMessageToServer(payload)
  }, [activeCampaignHasChatCta, activeCampaignId, activeCampaignPlaybookId, isInActiveCampaign, isInActiveConversation, isWelcomeMessageCampaign])

  return { sendMessage, sendChatMessage }
}

export default useSendMessage
